import { NavigateFunction, Location } from "react-router-dom"

const globalRouter = { navigate: null, location: null } as {
  navigate: NavigateFunction | any
  location: Location<any> | any
}

export default globalRouter
